<template src="./Add.html">
</template>

<script>

    export default {
        created() {
            this.$store.dispatch("lookups/getLookups")


        },
        computed: {
            types() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.ComplaintTypes)

            },

        },
        data() {
            return {
                complaint: {},
            };
        },
        methods: {
           
            confirm() {

                this.$store
                    .dispatch("complaints/add", this.complaint)
                    .then(() => {
                        this.back();
                    })
                    .catch(() => { });
            },

            back() {
                this.$emit("back");
            },
        },
    };
</script>